/* eslint-disable no-nested-ternary */
import { any, func } from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { postDrivingAssessment } from "../../../api/profileApi";
import Spinner from "../../../common/Spinner";
import Button from "../../../common/Button";
import {
  nonHGVPassed,
  nonHGVSubmitted,
} from "../../../redux/actions/formActions";

import * as style from "./styles.module.scss";

const NonHGVAssessment = ({ appData, setNonHGVSubmitted, setNonHGVPassed }) => {
  const [curQNumber, setCurQNumber] = useState(0);
  const [answers, setAnswer] = useState({});
  const [chosen, setChosen] = useState("");
  const [res, setRes] = useState(-1);
  const [loading, setLoading] = useState(false);

  const questions = [
    {
      question:
        "What should you do when moving off from behind a parked vehicle?",
      A: "Give a signal after moving off",
      B: "Check both interior and exterior mirrors",
      C: "Look around after moving off",
      D: "Use the exterior mirrors only",
    },
    {
      question:
        "By how much can stopping distances increase in icy conditions?",
      A: "Ten times",
      B: "Five times",
      C: "Three times",
      D: "Two times",
    },
    {
      question:
        "What should you do when you’re approaching traffic lights that have been on green for some time?",
      A: "Accelerate really hard",
      B: "Maintain your speed",
      C: "Be ready to stop",
      D: "Brake hard",
    },
    {
      question: "The symbol below refers to:",
      A: "No overtaking",
      B: "Cars and motorcycles only",
      C: "No motor vehicles ",
      D: "Clearway (no stopping)",
      imgSrc: "../../../../images/driving_assessments/nonHGV_Q4.PNG",
    },
    {
      question:
        "You are waiting to emerge left from a minor road. A large vehicle is approaching from the right. You have time to turn but you should wait. Why?",
      A: "The larger vehicle can easily hide an overtaking vehicle",
      B: "The larger vehicle can turn suddenly",
      C: "The larger vehicle is difficult to steer in a straight line",
      D: "The larger vehicle can easily hide vehicles from the left",
    },
    {
      question:
        "There are no speed limit signs on the road. How do you know it’s a 30 mph limit?",
      A: "By street lighting",
      B: "By double or single yellow lines",
      C: "By hazard warning lines",
      D: "By pedestrian islands",
    },
    {
      question: "What should you do before making a U-turn?",
      A: "Look over your shoulder for a final check",
      B: "Check signs to see if U-turns are permitted",
      C: "Select a higher gear than normal ",
      D: "Give an arm signal as well as using indicators",
    },
    {
      question: "Where would you expect to see these?",
      A: "On a large goods vehicle ",
      B: "On a railway bridge",
      C: "On a diversion sign",
      D: "On a motorway sign",
      imgSrc: "../../../../images/driving_assessments/nonHGV_Q8.PNG",
    },
    {
      question: "What should you do when joining a motorway?",
      A: "Give way to traffic already on motorway",
      B: "Stop at the end of the acceleration lane",
      C: "Use the hard shoulder ",
      D: "Slow to a stop before joining motorway",
    },
    {
      question:
        "What’s the purpose of road humps, sleeping policemen, chicanes and narrowings?",
      A: "To allow pedestrians to cross",
      B: "To increase traffic speed",
      C: "To decrease traffic speed",
      D: "To separate lanes of traffic",
    },
    {
      question:
        "You’re turning left into a side road. What should you be aware of?",
      A: "Pedestrians",
      B: "Traffic congestion",
      C: "Parked vehicles",
      D: "One way street",
    },
    {
      question:
        "You’re traveling in very heavy rain. How is this likely to affect your stopping distance?",
      A: "It will be halved ",
      B: "It won’t be any different",
      C: "It will be doubled ",
      D: "It will be ten times greater",
    },
    {
      question: "What does the sign below mean?",
      A: "No entry for vehicles",
      B: "No waiting on the carriageway",
      C: "National speed limit applies",
      D: "Local speed limit applies",
      imgSrc: "../../../../images/driving_assessments/nonHGV_Q13.PNG",
    },
    {
      question:
        "What is the national speed limit on motorways for cars, vans and motorcycles?",
      A: "50 mph",
      B: "30 mph",
      C: "60 mph",
      D: "70 mph",
    },
    {
      question:
        "You are driving along a road and need to stop on the roadside for delivery. You should NOT?",
      A: "Stop as close as you can to the side",
      B: "Switch off the engine",
      C: "Park facing against the traffic flow",
      D: "Apply the handbrake before getting out of the vehicle",
    },
    {
      question: "You will be disqualified from driving if you get?",
      A: "6 or more points within a 1 year period",
      B: "8 or more points within a 3 year period",
      C: "10 or more points within a 2 year period",
      D: "12 or more points within a 3 year period",
    },
    {
      question:
        "What is the daily driving limit for a 3.5 tonne vehicle driven for commercial use?",
      A: "9 hours",
      B: "10 hours",
      C: "11 hours",
      D: "12 hours",
    },
    {
      question:
        "How many hours per day can you be on ‘duty’ in a 3.5 tonne vehicle driven for commercial use?",
      A: "9 hours",
      B: "10 hours",
      C: "11 hours",
      D: "12 hours",
    },
    {
      question:
        "When is it acceptable to physically use your hand held device whilst driving",
      A: "Never",
      B: "When sat in traffic",
      C: "Anytime",
      D: "When my employer calls me",
    },
    {
      question: "When is it legal to smoke in a company vehicle?",
      A: "At weekends",
      B: "Never",
      C: "When parked at the side of the road ",
      D: "Always",
    },
  ];

  const nextQuestion = () => {
    const next = curQNumber + 1;
    setCurQNumber(next);
    setChosen(answers[next] || "");
  };

  const previousQuestion = () => {
    const previous = curQNumber - 1;
    setCurQNumber(previous);
    setChosen(answers[previous] || "");
  };

  const storeAnswer = (questionNumber, chosenAnswer) => {
    setChosen(chosenAnswer);
    setAnswer({ ...answers, [questionNumber - 1]: chosenAnswer });
  };

  const checkChosen = () => {
    if (chosen === "") {
      return false;
    }
    return true;
  };

  const loadChosen = () => {
    setChosen(answers[curQNumber]);
  };

  const [passed, setPassed] = useState(false);

  const submitTest = async () => {
    const result = await postDrivingAssessment(
      "nonHGVAsessement",
      `${appData.firstName} ${appData.lastName}`,
      answers
    ).then((obj) => {
      const { data } = obj;
      return data;
    });
    const pass = result >= 16;
    if (result >= 16) await setNonHGVPassed();
    setRes(result);
    setPassed(pass);
    return result;
  };

  const submitHandler = async () => {
    setLoading(true);
    await setNonHGVSubmitted();
    await submitTest();
    setLoading(false);
  };

  const populateAnswersAtoD = () => {
    return ["A", "B", "C", "D"].map((curAns) => {
      return (
        <div
          className={style.answer}
          key={curAns}
          onClick={() => storeAnswer(curQNumber + 1, curAns)}
          style={chosen === curAns ? { border: "2px solid #ff6600" } : null}
        >
          <span>{`${curAns})`}</span>
          <span>
            <input
              type="radio"
              name="option"
              checked={chosen === curAns}
              value={curAns}
              onChange={(event) =>
                storeAnswer(curQNumber + 1, event.target.value)
              }
            />
          </span>
          <span>{questions[curQNumber][curAns]}</span>
        </div>
      );
    });
  };

  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div className="col-sm-9 col-lg-8 p-2">
        <h2 className="section-header">Non HGV Driver Assessment</h2>
        <div>
          <p className="mb-2 font-weight-bold" style={{ fontSize: "20px" }}>
            {`Question ${curQNumber + 1} / ${questions.length}`}
          </p>
          <section className="section-body p-1">
            <h4 className="styles__resource__title___3swKq text-left">
              {questions[curQNumber].question}
            </h4>
            <div
              style={{ display: "flex", flexDirection: "row", width: "100%" }}
            >
              <div className={style.answersContainer}>
                {populateAnswersAtoD()}
              </div>
              {questions[curQNumber].imgSrc ? (
                <img className={style.img} src={questions[curQNumber].imgSrc} />
              ) : null}
            </div>
            <div className={style.container__buttons}>
              {questions[curQNumber] === questions[0] ? (
                <Link
                  style={{ textDecoration: "none" }}
                  to="/profile/edit/driving-onboarding"
                >
                  <Button classes="btn btn-block btn-outline-dark text-decoration-none">
                    Back
                  </Button>
                </Link>
              ) : (
                <Button
                  onClick={() => {
                    loadChosen();
                    previousQuestion();
                  }}
                  classes="btn btn-block btn-outline-dark text-decoration-none"
                >
                  Back
                </Button>
              )}
              {curQNumber === questions.length - 1 && res === -1 ? (
                <Button
                  disabled={loading || !checkChosen()}
                  onClick={() => {
                    submitHandler();
                  }}
                  id="btnBasicInfoEditSubmit"
                  classes="btn btn-primary"
                >
                  {loading ? <Spinner /> : "Submit"}
                </Button>
              ) : curQNumber === questions.length - 1 ? (
                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname:
                      "/profile/edit/driving-onboarding/assessment/feedback",
                    state: {
                      result: res,
                      numQuestions: questions.length,
                      retakeLink: "non-hgv-assessment",
                      testTitle: "Non HGV Driver Assessment",
                      passed,
                    },
                  }}
                >
                  <Button id="btnBasicInfoEditSubmit" classes="btn btn-primary">
                    Results
                  </Button>
                </Link>
              ) : (
                <Button
                  disabled={!checkChosen()}
                  onClick={() => {
                    nextQuestion();
                  }}
                  id="btnBasicInfoEditSubmit"
                  classes="btn btn-primary"
                  style={{ width: "80px" }}
                >
                  Next
                </Button>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

NonHGVAssessment.propTypes = {
  appData: any,
  setNonHGVSubmitted: func.isRequired,
  setNonHGVPassed: func.isRequired,
};

const mapDispatchToProps = {
  setNonHGVSubmitted: nonHGVSubmitted,
  setNonHGVPassed: nonHGVPassed,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(NonHGVAssessment);
